/*
 * Module for the DROP section of Account Overview
*/

rs.module("ui/content/account/overview/drop",

    ["controls/components/event-banner", "layouts/filedownload"],

    function (eventBanner, fileDownload) {

        // Initialize the DROP section
        function initialize(jsSelectors, backendUrls) {

            // Update the DROP detail based on the selected DROP Account
            $.js(jsSelectors.dropSelect, { required: false }).change(function () {
                $.get(
                    backendUrls.getDropDetail,
                    {
                        dropAccountKey: $(this).val()
                    })
                    .done(function (html) {
                        $.js(jsSelectors.dropDetail).html(html);
                    });
            });
        }

        // Initialize the DROP detail
        function initializeDetail(jsSelectors, backendUrls, dropAccountKey) {
            var form = $.js(jsSelectors.generateStatementForm);
            var periodBeginDate = form.js(jsSelectors.periodBeginDate);
            var periodEndDate = form.js(jsSelectors.periodEndDate);
            var generateStatementButtton = $.js(jsSelectors.generateStatementButton);
            var loadingSpinner = generateStatementButtton.js(jsSelectors.loadingSpinner);

            $.validator.resetValidation(form);

            generateStatementButtton.on("click", function (e) {

                eventBanner.removeAllMessages();

                if (!form.is(":visible")) {
                    e.preventDefault();

                    $(this).removeClass("btn-outline-primary").addClass("btn-primary");
                    form.toggle(400);
                    periodBeginDate.focus();

                    $('html,body').animate({ scrollTop: document.body.scrollHeight }, 400);
                }
                else {
                    // Validate form 
                    var validator = form.validate();
                    var isValid = validator.form();

                    if (isValid) {

                        loadingSpinner.show();
                        generateStatementButtton.setDisabled();
                        document.body.classList.add("wait");

                        $.ajax({
                            url: backendUrls.generateDropStatement,
                            type: "POST",
                            delayInformationalMessages: true,
                            data: {
                                dropAccountKey: dropAccountKey,
                                periodBeginDate: periodBeginDate.val(),
                                periodEndDate: periodEndDate.val()
                            }
                        }).done(function (result) {
                            fileDownload.initiateDownload(result.fileDownloadUrl, {
                                oncomplete: function () {
                                    loadingSpinner.hide();
                                    generateStatementButtton.setDisabled(false);
                                    document.body.classList.remove("wait");
                                }
                            });
                        }).fail(function () {
                            loadingSpinner.hide();
                            generateStatementButtton.setDisabled(false);
                            document.body.classList.remove("wait");
                        });
                    }
                }
            });
        }

        // Exported public API
        var exports = {
            initialize,
            initializeDetail
        };

        return exports;
    }
);